import AppAPI from '@/api'
import ComponentFormFooter from '@/components/forms/ComponentFormFooter'

export default {
  components: {
    'component-form-footer': ComponentFormFooter
  },
  data () {
    return {
      name: this.$options.name,
      newPosition: this.index + 1,
      isEditing: false,
      extensions: []
    }
  },
  props: {
    index: {type: Number, default: null},
    bus: {type: Object, default: null},
    positionMax: {type: Number, default: null},
    component: {type: Object, default: null},
    components: {type: Array, default: null},
    hideAll: {type: Boolean, default: false},
    lock: {type: Boolean, default: false},
    previewSize: {type: String, default: 'native'},
    inPreview: {type: Boolean, default: false}
  },
  computed: {
    contents: {
      get () { return this.component.contents }
    },
    url: {
      get () { return this.$store.getters['wordpress/account/url'] }
    },
    meta: {
      get () { return AppAPI.components[this.component.id].meta }
    },
    posts: {
      get () { return this.$store.getters['wordpress/posts/all'] }
    },
    publishedPosts: {
      get () { return this.$store.getters['wordpress/posts/published'] }
    },
    pages: {
      get () { return this.$store.getters['wordpress/pages/all'] }
    },
    publishedPages: {
      get () { return this.$store.getters['wordpress/pages/published'] }
    },
    media: {
      get () { return this.$store.getters['wordpress/media/all'] }
    },
    themes: {
      get () { return this.$store.getters['wordpress/themes/all'] }
    },
    settings: {
      get () { return this.$store.getters['wordpress/settings/all'] }
    },
    sectionId: {
      get () { return this.componentId(this) }
    },
    sectionClass: {
      get () { return `${this.meta.file} ${this.meta.file}-${this._uid} ${(this.contents.bg.isCustom ? `${this.meta.file}-${this._uid}-bg` : 'theme-base-bg-color')} slide` }
    },
    sectionClassArray: {
      get () { return [this.meta.file, 'slide', 'theme-base-bg-color'] }
    },
    sectionStyle: {
      get () { return this.contents.bg.isCustom ? 'background-color:' + this.contents.bg.color : '' }
    },
    containerClass: {
      get () { return (this.contents.fullWidth ? '' : 'container') + (this.contents.padding.y ? ' py' + this.contents.padding.y : '') }
    },
    containerClassArray: {
      get () { return [this.contents.fullWidth ? '' : 'container', 'py' + this.contents.padding.y] }
    },
    gridClass: {
      get () { return `grid grid-mx${this.contents.layout.margin} grid-my${this.contents.layout.margin} grid-1-${this.contents.layout.s} grid-1-${this.contents.layout.m}-m grid-1-${this.contents.layout.l}-l` }
    },
    gridClassArray: {
      get () { return ['grid', 'grid-mx' + this.contents.layout.margin, 'grid-my' + this.contents.layout.margin, 'grid-1-' + this.contents.layout.s, 'grid-1-' + this.contents.layout.m + '-m', 'grid-1-' + this.contents.layout.l + '-l'] }
    }
  },
  methods: {
    /**
     各コンポーネントに付与するIDを返す関数
     */
    componentId: function (that) {
      return that.component ? `${that.component.meta.file}-${that._uid}` : `${that.meta.file}-${that._uid}`
    },

    /**
     * uuid生成関数
     *
     * @see https://stackoverflow.com/questions/105034/create-guid-uuid-in-javascript/2117523#2117523
     */
    uuidv4: function () {
      return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, c =>
        (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
      )
    },

    /**
     * 文字色／背景色のインラインスタイルを取得する関数
     */
    getThemeInlineStyle: function (prop, type) {
      return `${prop}: rgba(${this.themes.colors[type].rgba.r}, ${this.themes.colors[type].rgba.g}, ${this.themes.colors[type].rgba.b}, ${this.themes.colors[type].rgba.a})`
    },

    /**
     * 引数で与えられるIDの固定ページを返す関数
     */
    getPageById: function (id) {
      return this.pages.find(page => page.id === id)
    },

    /**
     * 引数で与えられるIDの固定ページの子ページを返す関数
     */
    getSubPagesById: function (id) {
      return this.pages.filter(page => page.parent === id && page.status === 'publish')
    },

    /**
     * 適用ボタンを押すとthis.components.contentsからHTMLとCSSを
     * 生成してupdateイベントを発火する
     *
     * 適用ボタンを押すとthis.component.htmlとthis.component.cssを更新する
     */
    updateComponent: function () {
      if (process.env.NODE_ENV !== 'production') console.log(`Running updateComponent of ${this.name}...`)

      this.component.html = this.generateHtml(this.component.contents)
      this.component.css = this.generateCss(this.component.contents)
      this.$emit('update', {component: this.component, newPosition: this.newPosition})
      this.isEditing = false
    },

    updateComponentUid: function () {
      /**
       * this._uid は vue でコンポーネントが生成された際に発行される。
       * この値は発行時にユニークであるため、あとでコンポーネントが追加されたり
       * コンポーネント入れ替え時に新規に発行されても、最初に発行された this._uid とは被らない（はず）。
       * updateComponentUid が呼び出されたらイベントバスで uid-updated イベントを発火して、
       * this.component._uid に this._uid を代入して最新の this._uid をコンポーネント内に保持する
       *
       */
      if (this.component._uid !== this._uid) {
        if (process.env.NODE_ENV !== 'production') console.log(`%c_uid has been changed: ${this.component._uid} -> ${this._uid}`, 'color:blue')
        this.bus.$emit('uid-updated', this)
        this.component._uid = this._uid
        if (process.env.NODE_ENV !== 'production') console.log(`%c_uid has been updated: this.component._uid = ${this.component._uid}`, 'color:teal')
      }
    },

    updateComponentAndUid: function () {
      this.updateComponentUid()
      this.updateComponent()
    },

    /**
     * コンポーネント削除用のdeleteイベントを発火する
     */
    deleteComponent: function () {
      this.$emit('delete')
      this.isEditing = false
    }
  },
  /**
   * コンポーネント生成時にHTMLとCSSを生成してupdateイベントを発火する
   */
  created: function () {
    if (!this.component._uid) this.component._uid = this._uid
    if (this.component.uid) delete this.component.uid
    this.updateComponent()
  },
  /**
   * コンポーネントマウント時にmountedイベントを発火する
   */
  mounted: function () {
    this.$emit('mounted')
    this.bus.$on('update-child', this.updateComponentAndUid)
  }
}



// WEBPACK FOOTER //
// ./src/components/mixins/ComponentBase.js